<a
  class="exxon-badge-custom hide-when-empty"
  [class.p-0]="!badgeColor"
  [ngClass]="badgeColor">
  <ng-content *ngIf="!autoContent"></ng-content>
  <ng-container *ngIf="autoContent">
    {{ labelContent | translate | uppercase }}
  </ng-container>
</a>
